<template>
  <el-dialog
    title="设置会员"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="微信呢称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
              prop="legal"
              label="姓名"
      >
        {{legal}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="会员结束时间"
      >
        {{end_time}}
      </el-form-item>
      <el-form-item
        prop="prov_cd"
        label="增加会员天数"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择"

        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'twoagentyEditForm',
  props: {
    oneagent: Object,
    value: Boolean
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      userName: '',
      legal: '',
      end_time: '',
      agenttype: '',
      dl_type: '',
      form: {
        prov_cd: ''
      },
      typeOptions: [ {
        value: '日',
        label: '日会员'
      }, {
        value: '月',
        label: '月会员'
      }, {
        value: '半年',
        label: '半年会员'
      }, {
        value: '年',
        label: '年会员'
      }]
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {

    dialogOpen () {
      this.$refs.form.resetFields()
      if (this.oneagent.userId) {
        this.userName = this.oneagent.userName
        this.legal = this.oneagent.legal
        this.agenttype = this.oneagent.agenttype
        this.dl_type = this.oneagent.dl_type
        this.end_time = this.oneagent.end_time
      } else {
        this.form = {}
      }
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.oneagent.userId) {
            this.loading = true
            agentService.saveDltype({ ...this.form, agentid: this.oneagent.agentid })
              .then(data => {
                this.loading = false
                this.dialogVisible = false
                this.$emit('submit')
              })
          }
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
